export const updateFilterValue = (query, filterId, option, multiple, select) => {
    let newQuery = {...query}
    if (multiple) {
        const selectedOptions = [...(newQuery[filterId] || [])]
        // noinspection EqualityComparisonWithCoercionJS
        const index = selectedOptions.findIndex((v) => v == option.value)
        const exists = index !== -1
        if (select == null) {
            // toggle it using loose comparison
            select = !exists
        }

        if (select && !exists) {
            selectedOptions.push(option.value)
        } else if (!select && exists) {
            selectedOptions.splice(index, 1)
        }

        if (selectedOptions.length === 0) {
            delete newQuery[filterId]
        } else {
            newQuery = {...newQuery, [filterId]: selectedOptions}
        }
    } else {
        if (select == null) {
            const current = newQuery[filterId]
            // toggle it using loose comparison
            // noinspection EqualityComparisonWithCoercionJS
            select = current != option.value
        }
        if (select) {
            newQuery = {...newQuery, [filterId]: option.value}
        } else {
            delete newQuery[filterId]
        }
    }
    return newQuery
}
